/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerGetTeamTreeQueryResponse, TransferCustomersControllerGetTeamTreePathParams, TransferCustomersControllerGetTeamTree401, TransferCustomersControllerGetTeamTree403 } from "../../models/transferCustomersController/TransferCustomersControllerGetTeamTree";

function getTransferCustomersControllerGetTeamTreeUrl(salesforceId: TransferCustomersControllerGetTeamTreePathParams["salesforceId"], teamUuid: TransferCustomersControllerGetTeamTreePathParams["teamUuid"]) {
  const res = { method: 'GET', url: `/api/v1/transfer-customers/${salesforceId}/teams/${teamUuid}/tree` as const }  
  return res
}

/**
 * @summary Get folder/project/crunch tree for a team
 * {@link /api/v1/transfer-customers/:salesforceId/teams/:teamUuid/tree}
 */
export async function transferCustomersControllerGetTeamTree(salesforceId: TransferCustomersControllerGetTeamTreePathParams["salesforceId"], teamUuid: TransferCustomersControllerGetTeamTreePathParams["teamUuid"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransferCustomersControllerGetTeamTreeQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetTeamTree401 | TransferCustomersControllerGetTeamTree403>, unknown>({ method : "GET", url : getTransferCustomersControllerGetTeamTreeUrl(salesforceId, teamUuid).url.toString(), ... requestConfig })  
  return res.data
}